import { RouteMetadata } from './types';

export const systemAgentsMetadata: RouteMetadata[] = [
    {
        pattern: '/agents/:agentId/system-agents/:systemAgentId/access',
        section: 'system-agents',
        view: 'access',
        descriptionTemplate:
            'User is managing member access for system agent {systemAgentId} in organization {agentId}',
        capabilities: [
            'Enable or disable organization-wide access for this system agent',
            'Grant or revoke access for individual team members',
            'Review which members currently have access',
            'Synchronize member access state with the current team list',
        ],
        hints: [
            'Access management follows two steps: organization access first, then member access',
            'Member-level switches are disabled until organization-level access is enabled',
            'The selected system agent determines which access policy is being edited',
        ],
    },
    {
        pattern: '/agents/:agentId/system-agents/:systemAgentId/history',
        section: 'system-agents',
        view: 'history',
        descriptionTemplate: 'User is viewing execution history for system agent {systemAgentId}',
        capabilities: [
            'View historical runs for the selected system agent',
            'Filter runs by execution status',
            'Open run details and inspect logs',
            'Investigate failed executions',
        ],
        hints: [
            'System-agent history is backed by workflow runs using the agent-prefixed workflow ID',
            'Status filters come from URL search parameters',
            'Run details provide event-level visibility for debugging',
        ],
    },
    {
        pattern: '/agents/:agentId/system-agents/:systemAgentId/stats',
        section: 'system-agents',
        view: 'stats',
        descriptionTemplate: 'User is viewing performance stats for system agent {systemAgentId}',
        capabilities: [
            'View aggregate runs, success rate, latency, tokens, and cost',
            'Analyze daily trends for runs, threads, and cost',
            'Adjust the date range for analytics',
            'Inspect percentile latency metrics',
        ],
        hints: [
            'Date range selection is controlled by the daysBack search parameter',
            'Stats are computed from runs tied to the selected system agent',
            'Cost and token trends help identify regressions over time',
        ],
    },
    {
        pattern: '/agents/:agentId/system-agents/:systemAgentId',
        section: 'system-agents',
        view: 'overview',
        descriptionTemplate: 'User is viewing the overview for system agent {systemAgentId}',
        capabilities: [
            'Inspect system agent metadata and defaults',
            'Review configured tools and toolboxes',
            'Navigate to history, stats, and access tabs',
        ],
        hints: [
            'Overview summarizes configuration and token-related metadata',
            'Tool approval mode can affect runtime behavior',
            'The same agent can expose different operational tabs',
        ],
    },
    {
        pattern: '/agents/:agentId/system-agents',
        section: 'system-agents',
        view: 'list',
        descriptionTemplate: 'User is browsing the system agents catalog',
        capabilities: [
            'Browse available system agents by namespace',
            'Search system agents by name or description',
            'Open a system agent details view',
        ],
        hints: [
            'Namespace and search filters are represented in URL search parameters',
            'System agents are grouped by namespace such as workflow or console',
        ],
    },
];
